import { types } from "mobx-state-tree";
import { runInAction, makeAutoObservable } from "mobx";
// helpers
import StoreHelper from "src/base/helpers/store-helper";
import { formatPrice } from "src/base/helpers/price";
// models
import CartModel from "src/models/cart-model";
// apis
import CartApi from "src/store/apis/cart-api";

class CartStore {
  isFetching = true;
  isUpdating = false;
  carts = [];
  total = 0;

  constructor() {
    makeAutoObservable(this);
  }

  resetState() {}

  async fetchCarts(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      runInAction(() => {
        this.isFetching = true;
      });

      return await CartApi.read(reqParams)
        .then((response) => {
          if (response.success != 1) {
            return response.status;
          }

          let data = response.data;

          runInAction(() => {
            this.carts = data.carts.map((val) =>
              StoreHelper.createCartModel(val)
            );
            this.total = data.total;
          });

          return data;
        })
        .finally(() => {
          runInAction(() => {
            this.isFetching = false;
          });
        });
    } catch (e) {}
  }
  async storeCart(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      runInAction(() => {
        this.isUpdating = true;
      });

      return await CartApi.store(reqParams)
        .then((response) => {
          if (response.success != 1) {
            return response.status;
          }

          let data = response.data;

          return data;
        })
        .finally(() => {
          runInAction(() => {
            this.isUpdating = false;
          });
        });
    } catch (e) {}
  }

  get orderTotal() {
    let total = 0;

    this.carts.forEach((cart) => {
      total += cart.subTotal;
    });

    return total;
  }

  get orderTotalFmt() {
    const total: number = this.orderTotal;

    return formatPrice(total.toString());
  }
}

export default CartStore;
